import { PersonaContacto } from './persona-contacto';

export class PersonaUpdate extends PersonaContacto {
  public empresaNombre: string;
  public empresaCargo: string;
  public empresaProfesion: string;
  public empresaDireccion: string;
  public empresaTelefono: string;
  public isActive: boolean;
  public isVive: boolean;
  public isPendiente: boolean;
  public isTarifaPlena: boolean;
  public identificacion: string;
  public fechaLugarNacimiento: string;
  public rhNombre: string;
  public fechaActualiza: string;
  public isActualizado: string;

  constructor (json: any) {
    super(json);
    this.empresaNombre = json.empresaNombre || '';
    this.empresaCargo = json.empresaCargo || '';
    this.empresaProfesion = json.empresaProfesion || '';
    this.empresaDireccion = json.empresaDireccion || '';
    this.empresaTelefono = json.empresaTelefono || '';
    this.isActive = json.isActive;
    this.isVive = json.isVive;
    this.isPendiente = json.isPendiente;
    this.isTarifaPlena = json.isTarifaPlena;
    this.identificacion = json.identificacion;
    this.fechaLugarNacimiento = json.fechaLugarNacimiento;
    this.rhNombre = json.rhNombre || 'No disponible';
    this.fechaActualiza = json.fechaAccept;
    this.isActualizado = json.isActualizado || false;
  }
}
